import { withMotion } from '../hoc/with-motion';
import { NotFound } from '@/modules/layout/components/not-found';

const AnimatedPage = withMotion(NotFound);

export const roles: string[] = [];
export const path = '/*';
export const element = <AnimatedPage />